<template>
  <div
    class="wrap_item"
    :class="{
      'wrap_item-accordion': $vuetify.breakpoint.smAndDown,
      active: accordionStatus,
      'wrap_item-accordion--error':
        $vuetify.breakpoint.smAndDown && $slots.default[0].context.$refs[refChildName] &&
        !$slots.default[0].context.$refs[refChildName].valid,
    }"
  >
    <div class="wrap_item_head" @click="accordionStatus = !accordionStatus">
      <div class="wrap_container">
        <h2 class="wrap_title f32 fw300">
          {{ title }}
        </h2>
        <IconAccordion class="arrow" />
      </div>
    </div>
    <div class="wrap_item_body">
      <div class="wrap_container">
        <div class="itemBox">
          <slot ref="slot"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconAccordion from 'components/icons/IconAccordion'
export default {
  name: 'PersonalAreaAccordion',
  components: { IconAccordion },
  props: {
    title: String,
    refChildName: String,
  },
  data: () => ({
    accordionStatus: false,
  }),
}
</script>

<style lang="scss" scoped>
@import 'src/scss/wrap_accordion';
.wrap_item-accordion .wrap_item_body .itemBox {
  padding: 0 !important;
}
</style>
